
import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ConversationalOpportunityAudit } from "@/components/opportunity/ConversationalOpportunityAudit";
import { CareerArtifactIntelligence } from "@/components/career-tools/CareerArtifactIntelligence";

const OpportunityAuditPage = () => {
  const navigate = useNavigate();
  const [completedArtifacts] = useState(['assessment', 'big-sheet', 'power-moves', 'okrs']);
  const [userScore] = useState(78);

  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <div className="container max-w-7xl mx-auto px-3 sm:px-4 py-4 sm:py-6">
        <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/artifacts")}
            className="hover:bg-card-hover rounded-full touch-target-min"
          >
            <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5" />
            <span className="ml-2 hidden sm:inline">Back</span>
          </Button>
          <div className="min-w-0 flex-1">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Opportunity Audit
            </h1>
            <p className="text-text-secondary text-xs sm:text-sm md:text-base">
              Make data-driven decisions about your career moves
            </p>
          </div>
        </div>

        <div className="mb-6 sm:mb-8">
          <CareerArtifactIntelligence 
            userScore={userScore}
            completedArtifacts={completedArtifacts}
            recentActivity={['opportunity-audit']}
          />
        </div>

        <ConversationalOpportunityAudit />
      </div>
    </div>
  );
};

export default OpportunityAuditPage;
